import * as XLSX from "xlsx-js-style";
import { getDateTimeNow } from "./date-helpers";

type ExcelExportCellMapEntry = {
  displayAs: string;
  colWidth: number;
};
export type ExcelExportCellMap = ExcelExportCellMapEntry;

export const exportToExcel = (
  jsonData: any[],
  fileName: string,
  excelHeaderCellMap: Record<string, ExcelExportCellMap>
) => {
  // +++ filter jsonData, keeping only those columns specified in excelHeaderCellMap, in the specified order +++
  const filteredJsonData = [] as any;
  jsonData?.forEach((rowIn) => {
    const filteredJsonDataRow = {} as any;
    for (const key in excelHeaderCellMap) {
      const value = key
        .split(".")
        .reduce((acc, part) => acc && acc[part], rowIn);
      filteredJsonDataRow[key] = value;
    }
    filteredJsonData.push(filteredJsonDataRow);
  });
  // --- filter jsonData, keeping only those columns specified in excelHeaderCellMap, in the specified order ---

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON data to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(filteredJsonData);

  // +++ Map the header cell values to pretty names +++
  let i = 65;
  let done = false;
  worksheet["!cols"] = [];
  do {
    const char = String.fromCharCode(i);
    const key = `${char}1`;
    const xlCell = worksheet[key];
    if (xlCell === undefined) {
      done = true;
    } else {
      xlCell.s = { font: { bold: true } };
      const cellText = xlCell.v;
      const mapEntry = excelHeaderCellMap[cellText];
      if (mapEntry) {
        worksheet[key].v = mapEntry.displayAs;
        worksheet["!cols"].push({ wch: mapEntry.colWidth });
      } else {
        worksheet["!cols"].push({ wch: 10 });
      }
    }
  } while (++i < 91 && !done);
  // --- Map the header cell values to pretty names ---

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Generate a binary string representation of the workbook
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // Create a Blob from the binary string
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  // Create a link element to download the Blob as an Excel file
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}_${getDateTimeNow()}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
